import { Entity } from 'engine/Entity';
import { Facet } from 'engine/facets/Facet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { Waterable } from 'game/behaviors/Waterable';
import { PlantSprite } from 'game/sprites/PlantSprite';
import { WateredSprite } from 'game/sprites/WateredSprite';
import clamp from 'lodash/clamp';
import round from 'lodash/round';

interface PlantEntityProps {
  waterAmount: number,
  yOffset?: number,
}

class PlantBehavior extends Facet<PlantEntityProps> {

  water = (amount: number): boolean => {
    this.props.waterAmount = round(clamp(this.props.waterAmount + amount, 0, 1), 2);
    const watered = this.props.waterAmount === 1;
    return watered;
  };

  start() {
    const waterSprite = this.entity.getFacet(StaticSpriteFacet);
    if (waterSprite) waterSprite.props.opacity = this.props.waterAmount;
  }

  update() {
    const waterSprite = this.entity.getFacet(StaticSpriteFacet);
    if (waterSprite) waterSprite.props.opacity = this.props.waterAmount;
  }
}

export class PlantEntity extends Entity<PlantEntityProps> {

  water(amount: number): boolean {
    const behavior = this.getFacet(PlantBehavior);
    if (!behavior) return false;
    return behavior.water(amount);
  }

  createFacets(props: PlantEntityProps) {
    const behavior = create(PlantBehavior, props);
    const { yOffset = 0 } = props;
    return [
      behavior,
      create(StaticSpriteFacet, {
        frame: WateredSprite,
        offset: [-27.5, -23 + yOffset],
      }),
      create(StaticSpriteFacet, { frame: PlantSprite, offset: [0, yOffset] }),
      create(Waterable, {
        maxDistance: 5,
        offset: operator => [
          100 * Math.sign(operator.transform.position[0] - this.transform.position[0]),
          6,
        ],
        amountNeeded: () => round(1 - props.waterAmount, 2),
        water: behavior.water,
      }),
    ];
  }
}
